<template>
    <v-container>
        <v-flex xs12 sm12 md8 lg8 xl6 style="margin:auto">
            <v-card>
                <v-card-text>
                    <v-form>
                        <h4 class="primary--text " style="text-align: center">
                            {{this.$t('lang.user.changePassword')}}</h4>
                        <v-text-field type="password" ref="password" :label="$t('lang.user.oldPassword') + '*'"
                                      v-model.trim="user.oldPassword" name="oldPassword"
                                      v-validate="user.id?'min:8':'required'" maxLength="20"
                                      :data-vv-as="$t('lang.user.oldPassword')"
                                      :error-messages="errors.first('oldPassword')"
                        ></v-text-field>

                        <v-text-field type="password" ref="password" :label="$t('lang.user.newPassword') + '*'"
                                      v-model.trim="user.password" name="password"
                                      v-validate="user.id?'min:8':'required|min:8'" maxLength="20"
                                      :data-vv-as="$t('lang.user.newPassword')"
                                      :error-messages="errors.first('password')"
                        ></v-text-field>

                        <v-text-field type="password" :label="$t('lang.user.retypeNewPassword') + '*'"
                                      v-model.trim="user.passwordConf" name="passwordConf"
                                      v-validate="user.id?'confirmed:password':'required|confirmed:password'"
                                      ref="passwordConf"
                                      :data-vv-as="$t('lang.user.retypeNewPassword')"
                                      :error-messages="errors.first('passwordConf')"
                        ></v-text-field>
                    </v-form>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn class="yoprimary" dark @click="handleSubmit">
                        {{$t('lang.common.save')}}
                    </v-btn>
                    <v-btn color="error" @click="back">
                        {{$t('lang.common.back')}}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-flex>
    </v-container>
</template>

<script>
    import {router} from "../router";
    import {mapState} from "vuex";
    import {Validator} from "vee-validate";
    import {CrudService} from "@/services";
    import {roleService} from "@/services";
    import axios from "axios";
    import {message} from "@/shared/message";
    import IUpload from "../components/form/Upload";
    import IDatepicker from "../components/form/DatePicker";

    export default {
        name: "change-pass",
        components: {IDatepicker, IUpload},
        data() {
            return {
                submitted: false,
                user: {
                    status: 1
                },
            };
        },
        computed: mapState({
            loading: state => state.common.loading,
        }),
        methods: {
            handleSubmit(e) {
                this.$validator.validate().then(valid => {
                        if (valid) {
                            axios.post(process.env.VUE_APP_API_URL + "/changePass", this.user).then(
                                data => {
                                    if (!data.success) {
                                        message.error(this.$t(data.description));
                                    } else {
                                        message.success(this.$t('lang.common.update_success'));
                                    }
                                }
                            )
                        }
                    }
                );
            },
            back() {
                this.$router.go(-1);
            }
        },
        created() {
        },
        mounted() {
        }
    };
</script>
